import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  downloadCustomerList,
  fetchCustomers,
} from "../../../Redux/actions/customerActions";
import {
  Typography,
  TextField,
  InputAdornment,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Menu,
} from "@mui/material";
import classes from "./customer.module.css";
import CustomerListItem from "./CustomerListItem";
import Pagination from "../../../Components//Pagination";
import FilterButton from "../../../Components/Filters/FilterButton";
import FilterDrawer from "../../../Components/Filters/FilterDrawer";
import CheckboxFilterGroup from "../../../Components/Filters/CheckboxFilterGroup";
import StatusFilter from "../../../Components/Filters/StatusFilter";
import DateRangeFilter from "../../../Components/Filters/DateRangeFilter";
import {
  CustomerDesignationFilter,
  CustomerIndustyFilter,
  InvoiceFilterAction,
  subscriptionFilter,
} from "../../../Redux/actions/filterActions";
import {
  DatePickerCalendarIcon,
  OppositeSortArrawBtnIcons,
  SearchIcon,
  SortArrawBtnIcons,
} from "../../../Components/Icons/Icons";
import { ValidatorForm } from "react-material-ui-form-validator";
import dayjs from "dayjs";
import { handleSortClick } from "../../../Utilities/commonfunctions";
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

const Customers = ({ fromDate, toDate }) => {
  const PaginationData = useSelector(
    (state) => state.paginationData.Pagination
  );
  const { rowCount, currentPage } = PaginationData || {};
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const filterData = useSelector((state) => state.filter);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [filterFromDate, setFilterFromDate] = useState(null);
  const [filterToDate, setFilterToDate] = useState(null);
  const [filterOpen, setFilterOpen] = useState(false);
  const { industries, designation, invoice, sortBy, subscriptionTypes } =
    filterData || {};
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [designations, setDesignations] = useState();

  useEffect(() => {
    const filterArray = {
      userType: designation,
      industry: industries,
      active: invoice,
      subType: subscriptionTypes,
    };
    console.log(filterArray);
    dispatch(
      fetchCustomers(
        currentPage,
        rowCount,
        search,
        filterArray,
        sortBy,
        filterFromDate || fromDate,
        filterToDate || toDate
      )
    );
  }, [
    dispatch,
    currentPage,
    rowCount,
    search,
    industries,
    designation,
    invoice,
    sortBy,
    subscriptionTypes,
    fromDate,
    toDate,
    filterFromDate,
    filterToDate,
  ]);

  const customerList = useSelector((state) => state.customerData);
  const { loading, error, customers, totalCount } = customerList || {};
  console.log("customers", customers);

  useEffect(() => {
    const resultArray = customers
      ?.map((c) => c.designation)
      .filter((v, i, self) => v && self.indexOf(v) === i);
    setDesignations(resultArray);
  }, [customers]);

  const handleSubmit = () => {
    dispatch(
      downloadCustomerList(
        dayjs(startDate).format("YYYY-MM-DD"),
        dayjs(endDate).format("YYYY-MM-DD")
      )
    );
    handleClose();
  };

  const handleClearAll = () => {
    dispatch(CustomerIndustyFilter([]));
    dispatch(CustomerDesignationFilter([]));
    dispatch(subscriptionFilter([]));
    dispatch(InvoiceFilterAction([]));
    setFilterFromDate(null);
    setFilterToDate(null);
  };

  const activeCount =
    (industries?.length || 0) +
    (designation?.length || 0) +
    (subscriptionTypes?.length || 0) +
    (invoice?.length || 0) +
    (filterFromDate ? 1 : 0) +
    (filterToDate ? 1 : 0);

  return (
    <div>
      {window.location.pathname.includes("dashboard") ? null : (
        <div className={classes.HeaderInputContainer}>
          <div>
            <TextField
              sx={{
                "& legend": {
                  display: "none",
                },
                "& fieldset": {
                  top: 0,
                },
              }}
              placeholder="Search"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              className={classes.teamMemberSearch}
              id="firstNameinput"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              size="small"
            />
          </div>
          <div className={classes.HeaderFiltersRow}>
          <FilterButton
            activeCount={activeCount}
            onClick={() => setFilterOpen(true)}
          />
          <div>
            {/* <TextField
              sx={{
                "& legend": {
                  display: "none",
                },
                "& fieldset": {
                  top: 0,
                },
              }}
              placeholder="Download Customer List"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <DatePickerCalendarIcon />
                  </InputAdornment>
                ),
              }}
              aria-controls={open ? "demo-positioned-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              className={classes.teamMemberReport}
              id="firstNameinput"
              value={search}
              onClick={handleClick}
              size="small"
            /> */}
            <Button
              sx={{
                color: "#737387",
                border: "#737387 1px solid",
              }}
              variant="outlined"
              className={classes.teamMemberReport}
              aria-controls={open ? "demo-positioned-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
              onClick={handleClick}
            >
              <span> Download Customer List</span>
              <DatePickerCalendarIcon />
            </Button>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
              sx={{ minWidth: "450px" }}
            >
              <div style={{ padding: "20px" }}>
                <Typography
                  className={`mb-3 ${classes.modalHEadingCustomerFilter}`}
                  style={{
                    fontWeight: "600",
                  }}
                >
                  Download Customer List
                </Typography>
                <ValidatorForm useref="form" onSubmit={handleSubmit}>
                  {/* <div className="mb-3">
                    <Typography className={`mb-2 ${classes.form_lable}`}>
                      Duration
                    </Typography>
                    <TextValidator
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                        width: 345,
                      }}
                      select
                      fullWidth
                      className={classes.inputs}
                      value={duration}
                      onChange={(e) => {
                        setDuration(e.target.value);
                      }}
                      required={true}
                      size="small"
                    >
                      <MenuItem value="select">Select Duration</MenuItem>
                    </TextValidator>
                  </div> */}
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <Typography className={`mb-3 ${classes.secondImportText}`}>
                      Date Range
                    </Typography>
                    <Typography className={`mb-2 ${classes.form_lable}`}>
                      from
                    </Typography>
                    <div className="mb-3">
                      <DesktopDatePicker
                        label="From"
                        value={startDate}
                        onChange={(newValue) => setStartDate(newValue)}
                        format="DD/MM/YYYY"
                        slots={{ openPickerIcon: DatePickerCalendarIcon }}
                        slotProps={{
                          textField: {
                            size: 'small',
                            sx: {
                              "& legend": { display: "none" },
                              "& fieldset": { top: 0 },
                            },
                          },
                        }}
                      />
                    </div>
                    <Typography className={`mb-2 ${classes.form_lable}`}>
                      to
                    </Typography>
                    <div className="mb-3">
                      <DesktopDatePicker
                        label="To"
                        value={endDate}
                        onChange={(newValue) => setEndDate(newValue)}
                        format="DD/MM/YYYY"
                        slots={{ openPickerIcon: DatePickerCalendarIcon }}
                        slotProps={{
                          textField: {
                            size: 'small',
                            sx: {
                              "& legend": { display: "none" },
                              "& fieldset": { top: 0 },
                            },
                          },
                        }}
                      />
                    </div>
                  </LocalizationProvider>
                  <div className={`mt-4 ${classes.customerPagebtnSection}`}>
                    <Button variant="outlined" onClick={handleClose}>
                      Cancel
                    </Button>
                    <Button variant="contained" type="submit">
                      Confirm
                    </Button>
                  </div>
                </ValidatorForm>
              </div>
            </Menu>
          </div>
          </div>
        </div>
      )}
      <div className={classes.tableContainer}>
        <Table className={classes.MainTable}>
          <TableHead>
            <TableRow className={classes.tableHeadRow}>
              <TableCell className={classes.tableHeadCell}>
                <div>
                  <span> Customer </span>
                  <span
                    onClick={() =>
                      handleSortClick(dispatch, sortBy, "company.company_name")
                    }
                  >
                    {sortBy?.includes("desc") &&
                    sortBy?.includes("company.company_name") ? (
                      <OppositeSortArrawBtnIcons />
                    ) : (
                      <SortArrawBtnIcons />
                    )}
                  </span>
                </div>
              </TableCell>{" "}
              <TableCell className={classes.tableHeadCell}>
                <div className={classes.tableHEadercelldiv}>
                  <span> Contact Person </span>
                  <span
                    onClick={() =>
                      handleSortClick(dispatch, sortBy, "user.name")
                    }
                  >
                    {sortBy?.includes("desc") &&
                    sortBy?.includes("user.name") ? (
                      <OppositeSortArrawBtnIcons />
                    ) : (
                      <SortArrawBtnIcons />
                    )}
                  </span>
                </div>
              </TableCell>{" "}
              <TableCell className={classes.tableHeadCell}>
                <span> Email </span>
              </TableCell>{" "}
              <TableCell className={classes.tableHeadCell}>
                <span> Phone </span>
              </TableCell>{" "}
              <TableCell className={classes.tableHeadCell}>
                <span> Location </span>
                <span
                  onClick={() =>
                    handleSortClick(dispatch, sortBy, "company.address_two")
                  }
                >
                  {sortBy?.includes("desc") &&
                  sortBy?.includes("company.address_two") ? (
                    <OppositeSortArrawBtnIcons />
                  ) : (
                    <SortArrawBtnIcons />
                  )}
                </span>
              </TableCell>{" "}
              <TableCell className={classes.tableHeadCell}>
                <div className={classes.tableHEadercelldiv}>
                  <span> Industry </span>{" "}
                  <span
                    onClick={() =>
                      handleSortClick(dispatch, sortBy, "company.industry")
                    }
                  >
                    {sortBy?.includes("desc") &&
                    sortBy?.includes("company.industry") ? (
                      <OppositeSortArrawBtnIcons />
                    ) : (
                      <SortArrawBtnIcons />
                    )}
                  </span>
                </div>
              </TableCell>{" "}
              <TableCell className={classes.tableHeadCell}>
                <div className={classes.tableHEadercelldiv}>
                  <span> Subscriptions </span>
                  <span
                    onClick={() =>
                      handleSortClick(
                        dispatch,
                        sortBy,
                        "SubscriptionData.total"
                      )
                    }
                  >
                    {sortBy?.includes("desc") &&
                    sortBy?.includes("SubscriptionData.total") ? (
                      <OppositeSortArrawBtnIcons />
                    ) : (
                      <SortArrawBtnIcons />
                    )}
                  </span>
                </div>
              </TableCell>{" "}
              {/* Base Example */}{" "}
              <TableCell className={classes.tableHeadCell}>
                <span> Joining Date </span>
                <span
                  onClick={() => handleSortClick(dispatch, sortBy, "createdAt")}
                >
                  {sortBy?.includes("desc") && sortBy?.includes("createdAt") ? (
                    <OppositeSortArrawBtnIcons />
                  ) : (
                    <SortArrawBtnIcons />
                  )}
                </span>
              </TableCell>{" "}
              <TableCell className={classes.tableHeadCell}>
                <div className={classes.tableHEadercelldiv}>
                  <span> Status </span>
                </div>
              </TableCell>{" "}
              <TableCell className={classes.tableHeadCell} style={{ width: 40, padding: 0 }} />{" "}
            </TableRow>{" "}
          </TableHead>{" "}
          <TableBody
            className={`list form-check-all ${classes.MainTable}`}
            style={{ height: "100%" }}
          >
            {" "}
            {/* loop customer.data is > 0 */}{" "}
            {loading ? (
              <TableRow>
                <TableCell colSpan="10" className="text-center">
                  Loading...
                </TableCell>{" "}
              </TableRow>
            ) : error ? (
              <TableRow>
                <TableCell colSpan="10" className="text-center">
                  {" "}
                  {error}{" "}
                </TableCell>{" "}
              </TableRow>
            ) : customers && customers.length > 0 ? (
              customers
                .slice()
                .map((item, index) => (
                  <CustomerListItem key={index} customer={item} />
                ))
            ) : (
              <TableRow>
                <TableCell colSpan="10" className="text-center">
                  No Data Found{" "}
                </TableCell>{" "}
              </TableRow>
            )}{" "}
          </TableBody>{" "}
        </Table>{" "}
      </div>
      <Pagination total={totalCount} />

      <FilterDrawer
        open={filterOpen}
        onClose={() => setFilterOpen(false)}
        onClearAll={handleClearAll}
      >
        <CheckboxFilterGroup
          label="Industry"
          options={indestry}
          selected={industries}
          action={CustomerIndustyFilter}
        />
        <CheckboxFilterGroup
          label="Designation"
          options={designations}
          selected={designation}
          action={CustomerDesignationFilter}
        />
        <CheckboxFilterGroup
          label="Subscriptions"
          options={["active", "expired", "expiring_soon"]}
          selected={subscriptionTypes}
          action={subscriptionFilter}
        />
        <StatusFilter label="Status" selected={invoice} />
        <DateRangeFilter
          label="Joining Date"
          from={filterFromDate}
          to={filterToDate}
          onFromChange={(val) => setFilterFromDate(val)}
          onToChange={(val) => setFilterToDate(val)}
        />
      </FilterDrawer>
    </div>
  );
};

export default Customers;

const indestry = [
  "advertising / marketing",
  "agriculture",
  "architecture / interior design",
  "automobile",
  "aviation",
  "banking/insurance",
  "bpo / call centre",
  "consultation services",
  "courier / logistics",
  "education",
  "entertainment",
  "financial services",
  "government",
  "hospitality",
  "import / export",
  "it (information technology)",
  "jewellery",
  "legal services",
  "manufacturing / processing",
  "media / news",
  "medical / pharmaceutical",
  "mining",
  "oil / gas / power",
  "printing / publishing",
  "railways",
  "real estate",
  "recruitment / staffing",
  "retail",
  "security / law enforcement",
  "textile",
  "travel / tourism",
  "warehousing / wholesale",
];
